<template>
  <div class="onlineTraining">
    <div class="statusBar"></div>

    <div class="onlineContent">
      <div class="video">
        <img src="@/assets/images/detail/back_white.png" alt="" class="back" @click="back" />
        <Video id="myVideo" ref="videoPlayer" class="video-js vjs-big-play-centered" :poster="detailInfo.picUrl"></Video>
      </div>
      <div class="introduction">
        <div class="d-f jc-sb ai-c">
          <span class="title">{{ detailInfo.name }}</span>
          <!-- <div class="d-f ai-c view_total"><img src="@/assets/images/detail/culturalCollection/view.png" alt="" class="icon" /> <span>123</span></div> -->
        </div>
        <div class="tags d-f ai-c">
          <!-- <div class="tag_item">{{ detailInfo.artType }}</div> -->
          <div class="tag_item">{{ detailInfo.artTypeName }}</div>
        </div>
        <div class="common_msg date d-f ai-c">
          <img src="@/assets/images/detail/performance/speaker.png" alt="" class="icon" />
          <span>主讲老师：{{ detailInfo.personName }}</span>
        </div>
        <div class="common_msg d-f ai-c">
          <img src="@/assets/images/detail/culturalCollection/company_grey.png" alt="" class="icon" />
          <span>发布单位：{{ detailInfo.publishUnitName }}</span>
        </div>
      </div>

      <div class="change_hour">
        <div class="title_hour">选择课时</div>

        <div class="content_box">
          <div class="hour_item d-f fxd-c" v-for="(item, index) in detailInfo.videoList" :key="index" @click="changeVideo(item, index)">
            <img :src="detailInfo.picUrl" alt="" class="hour_img" />
            <div class="title" :class="videoIndex == index ? 'active' : ''">第{{ index + 1 }}课时：{{ item.name }}</div>
          </div>
        </div>
      </div>

      <div class="content" v-if="detailInfo.detail">
        <div class="title">视频简介</div>
        <div class="fuwenben" v-html="detailInfo.detail"></div>
      </div>
      <div class="handle_button d-f jc-sb ai-c">
        <div class="handle_item d-f ai-c jc-c border_right" @click="showShare = true">
          <img src="@/assets/images/detail/performance/share_grey.png" alt="" class="icon_handle" />
          <span style="white-space: pre-wrap; display: inline-block; width: 30px">分享</span>
        </div>
        <div class="handle_item d-f ai-c jc-c" @click="handleFavorite">
          <img src="@/assets/images/detail/performance/collect.png" alt="" class="icon_handle" v-if="!detailInfo.isFavorite" />
          <img src="@/assets/images/detail/culturalCollection/collect.png" alt="" class="icon_handle" v-else />
          <!-- <img src="@/assets/images/detail/performance/collect.png" alt="" class="icon_handle" /> -->
          <span>收藏</span>
        </div>
      </div>
    </div>
    <van-share-sheet title="分享到" v-model="showShare" :options="shareOptions" @select="onSelect" />
  </div>
</template>
<script>
import videojs from 'video.js'
import 'video.js/dist/video-js.css'
import { mapGetters } from 'vuex'
import { onlineDetail, saveVideoLog } from '@/api/cultivate'
import { submitUserFavorite, cancelFavorite } from '@/api/operation'
import config from '@/utils/config.js'

export default {
  name: 'onlineTraining',
  data() {
    return {
      detailInfo: {},
      showShare: false,
      id: '',
      mediaUrl: require('@/assets/images/detail/performance/video.mp4'), // 播放视频的路径
      timeParams: {
        videoId: '',
        duration: '',
      },
      videoIndex: 0,
      options: {
        autoplay: false,
        controls: true,
        preload: 'auto',
        sources: [],
        width: '100%',
        height: '100%',
        controlBar: {
          playToggle: true,
        },
      },
      isPlay: false,
      testUrl: 'http://vjs.zencdn.net/v/oceans.mp4',
      shareUrl: config.shareUrl,
    }
  },
  computed: {
    ...mapGetters(['shareOptions']),
  },
  methods: {
    back() {
      if (this.isPlay && this.player.currentTime() < this.player.duration()) {
        this.timeParams.duration = this.player.currentTime()
        this.saveProgress()
      }
      setTimeout(() => {
        this.$myUni.navigateBack({
          delta: 1,
        })
      }, 300)
    },
    async videoInit() {
      // 初始化video.js播放器
      this.$nextTick(() => {
        this.player = videojs('myVideo', this.options)
        // this.detailInfo.videoList[this.videoIndex].videoUrl = this.testUrl
        this.player.src(this.detailInfo.videoList[this.videoIndex].videoList[0].videoUrl)

        this.player.on('play', () => {
          console.log('开始播放')
          this.isPlay = true
        })
        this.player.on('ended', () => {
          console.log('播放完成')
        })
        this.player.on('pause', () => {
          this.isPlay = false
          console.log('整体时长', this.player.duration())
          console.log('播放暂停', this.player.currentTime())
          if (this.player.currentTime() < this.player.duration()) {
            this.timeParams.duration = this.player.currentTime()
            this.saveProgress()
          }
        })
      })
    },
    async getDetail() {
      const res = await onlineDetail(this.id)
      if (res.code == 2000) {
        this.detailInfo = res.result
        // this.detailInfo.videoUrl = this.testUrl
      }
    },
    saveProgress() {
      saveVideoLog(this.timeParams).then((res) => {})
    },
    changeVideo(item, index) {
      if (index !== this.videoIndex) {
        this.videoIndex = index
        // this.detailInfo.videoList[this.videoIndex].videoUrl = this.testUrl
        this.player.src(this.detailInfo.videoList[this.videoIndex].videoList[0].videoUrl)
      }
    },
    handleFavorite() {
      if (!this.detailInfo.isFavorite) {
        // 收藏
        submitUserFavorite({ type: 6, basicId: this.id }).then((res) => {
          if (res.code == 2000) {
            // this.getDetail()
            this.detailInfo.isFavorite = !this.detailInfo.isFavorite
          }
        })
      } else {
        // 取消收藏
        cancelFavorite({ type: 6, basicId: this.id }).then((res) => {
          if (res.code == 2000) {
            // this.getDetail()
            this.detailInfo.isFavorite = !this.detailInfo.isFavorite
          }
        })
      }
    },
    onSelect(option) {
      console.log('option====>', option)
      const url = `${this.shareUrl}/share/onlineTraining?id=${this.id}`
      this.$myUni.postMessage({
        data: {
          methodsName: 'UNIShare',
          UNISharedata: {
            // 微信好友 朋友圈 QQ好友 复制链接
            shareType: option.name,
            shareUrl: url,
            id: this.id,
            title: this.detailInfo.name,
            subTitle: '',
            picUrl: this.detailInfo.picUrl,
          },
        },
      })
      this.showShare = false
    },
  },

  mounted() {
    const data = JSON.parse(this.$route.query.params)
    this.id = this.timeParams.videoId = data.id
    this.getDetail()
    setTimeout(() => {
      this.videoInit()
    }, 300)
  },
  beforeDestroy() {
    this.player.dispose()
  },
}
</script>
<style lang="scss" scoped>
.onlineTraining {
  width: 100%;
  height: 100vh;
  background: #fff;
  // margin-bottom: calc(2.5rem + env(safe-area-inset-bottom));
  .statusBar {
    z-index: 10;
    position: fixed;
    top: 0;
    // top: env(safe-area-inset-top);
    left: 0;
    width: 100%;
    height: 40px;
    background: #010101;
  }
  .onlineContent {
    width: 100%;
    // height: calc(100% - 40px - env(safe-area-inset-top));
    height: calc(100% - 40px - 58px - env(safe-area-inset-bottom));
    position: absolute;
    // top: calc(40px + env(safe-area-inset-top));
    top: 40px;
    left: 0;
    overflow-y: auto;
  }

  .tag_item {
    font-size: 0.6rem;
    padding: 0 0.3rem;
    // color: #47988aff;
    color: #a97048;
    height: 0.9rem;
    line-height: 0.9rem;
    // background: #bedada;
    background: #f9eddc;
    border-radius: 2px;
    margin-right: 0.4rem;
    margin-top: 0.4rem;
  }
  .video {
    width: 100%;
    height: 10.55rem;
    .back {
      z-index: 10;
      position: absolute;
      width: 0.6rem;
      height: 1.2rem;
      left: 0.8rem;
      top: 8px;
      // top: calc(40px + env(safe-area-inset-top));
    }
    .video-player {
      width: 100%;
      height: 100%;
    }
  }
  .introduction {
    padding: 0.8rem 0;
    margin: 0 0.6rem;
    border-bottom: 1px solid #f4f4f4;
    .icon {
      width: 0.7rem;
      height: 0.7rem;
      margin-right: 2px;
    }
    .title {
      font-size: 0.9rem;
      font-weight: 600;
      color: #212121;
      line-height: 1.4rem;
    }
    .view_total {
      font-size: 0.5rem;
      color: #47988a;
      text-align: center;
      height: 0.9rem;
      line-height: 0.9rem;
      background: #dff2f2;
      border-radius: 2px;
      padding: 0 0.3rem;
    }
    .common_msg {
      font-size: 0.6rem;
      color: #666666;
      line-height: 0.8rem;
    }
    .date {
      margin: 0.6rem 0 0.3rem 0;
    }
  }
  .change_hour {
    width: 100%;
    // height: 6rem;
    overflow: hidden;
    padding-left: 0.6rem;
    .title_hour {
      font-size: 0.8rem;
      font-weight: 600;
      color: #212121;
      line-height: 1.2rem;
      margin: 0.75rem 0 0.6rem 0;
    }
    .content_box {
      overflow-x: auto;
      white-space: nowrap;
      display: flex;
      align-items: start;
      width: 100%;
      .hour_item {
        display: inline-block;
        width: 6.4rem;
        // height: 6rem;
        // overflow: hidden;
        margin-right: 0.6rem;

        .hour_img {
          width: 6.4rem;
          height: 3.6rem;
          border-radius: 0.5rem;
        }
        .title {
          white-space: normal;
          font-size: 0.7rem;
          color: #212121;
          line-height: 1rem;
          white-space: wrap;
          overflow: hidden;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          text-overflow: ellipsis;

          &.active {
            color: #a97048;
          }
        }
      }
    }
  }
  .content {
    font-size: 0.7rem;
    color: #666666;
    line-height: 1rem;
    padding: 0 0.6rem;
    .title {
      margin: 0.75rem 0 0.6rem 0;
      font-size: 0.8rem;
      font-weight: 600;
      color: #212121;
      line-height: 1.2rem;
    }
    .fuwenben {
      width: 100%;
      overflow: auto;
    }
  }
  .handle_button {
    position: fixed;
    bottom: 0;
    left: 0;
    height: 2.9rem;
    width: 100%;
    background: #fff;
    padding: 0.6rem 0.6rem 0 0.6rem;
    font-size: 0.7rem;
    color: #212121;
    line-height: 1rem;
    padding-bottom: calc(0.6rem + env(safe-area-inset-bottom));
    .handle_item {
      width: 50%;
      &.border_right {
        // padding-right: 0.6rem;
        position: relative;
        ::after {
          position: absolute;
          content: '';
          display: inline-block;
          width: 1px;
          height: 0.7rem;
          top: 0.35rem;
          right: 0;
          background: #cccccc;
        }
      }
      &.border_left {
        padding-left: 0.6rem;
      }
      .icon_handle {
        width: 1.4rem;
        height: 1.4rem;
        margin-right: 0.4rem;
      }
    }
    .btn {
      width: 50%;
      text-align: center;
      height: 1.8rem;
      line-height: 1.8rem;
      background: #47988a;
      border-radius: 0.9rem;
      font-size: 0.7rem;
      color: #ffffff;
    }
  }
}
</style>
